// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"styles__chartContainer--2drwl","title":"styles__title--EJP6a"};